import { lazy, Suspense } from "react";
import { BotBPass } from "./types";
import { publishModalData, publishModalProps, publishModalVisibility } from "../../redux/features/modal/modalSlice";
import { useAppDispatch } from "../../redux/hooks";
import UpsellSubscriptionProvider from "../upsell-subscription-modal/upsell-subscription-provider";
import UpsellSubscriptionModal from "../upsell-subscription-modal/page-content";

// Lazy: react-markdown (~260 KiB of source with its micromark/mdast stack) only loads when this
// menu section actually renders.
const Markdown = lazy(() => import("react-markdown"));

const BotBPassNavMenu = ({ navMenuData }: { navMenuData: BotBPass }) => {
  const dispatch = useAppDispatch();
  const fromNavMenu = true;
  const BotbPassClick = () => {
    dispatch(
      publishModalData({
        modalData: (
          <>
            <UpsellSubscriptionProvider>
              <UpsellSubscriptionModal fromNavMenu={fromNavMenu} okClick={"/botb-pass?utm_medium=menu_entry"} />
            </UpsellSubscriptionProvider>
          </>
        ),
      })
    );
    dispatch(publishModalProps({ withOverlay: true }));
    dispatch(publishModalVisibility({ isOpen: true }));
  };

  return (
    <div className="botb-pass-nav-menu-container w-full">
      <div className="text-gray-1 font-jost text-xs lg:text-sm font-medium leading-4 lg:leading-5 uppercase">
        PLAY MORE, PAY LESS
      </div>
      <ul className="mt-3 lg:mt-5">
        <li
          onClick={BotbPassClick}
          className="relative flex overflow-hidden items-center w-full h-20 lg:h-[88px] pr-4 lg:pr-3 gap-0 rounded-lg lg:rounded-xl bg-red-to-orange cursor-pointer">
          <div className="relative shrink-0 w-[99px] lg:w-[117px] h-full overflow-hidden">
            <img
              src="/assets/images/menu/botb-pass/trophy-mobile.webp"
              alt=""
              width={99}
              height={80}
              className="absolute inset-0 size-full object-cover object-left pointer-events-none lg:hidden"
            />
            <img
              src="/assets/images/menu/botb-pass/trophy-desktop.webp"
              alt=""
              width={117}
              height={88}
              className="absolute inset-0 hidden lg:block size-full object-cover object-left pointer-events-none"
            />
          </div>
          <div className="flex grow items-center gap-2 lg:gap-5 min-w-0">
            <div className="flex flex-col grow items-start justify-center min-w-0 leading-[0]">
              <span className="text-white font-jost text-[18px] lg:text-[20px] font-bold leading-6">
                {navMenuData.MainText}
              </span>
              <span className="font-jost text-[12px] lg:text-[16px] font-normal leading-[1.2] text-white/80 break-words">
                {/* Fallback shows the raw text (markdown markers stripped) for the few ms the chunk loads */}
                <Suspense fallback={<>{navMenuData.SubText?.replace(/\*\*/g, "")}</>}>
                  <Markdown
                    components={{
                      strong: props => <span className="font-semibold text-white">{props.children}</span>,
                    }}>
                    {navMenuData.SubText}
                  </Markdown>
                </Suspense>
              </span>
            </div>
            <span className="flex shrink-0 items-center justify-center w-[68px] lg:w-20 h-10 bg-blue rounded-lg text-white text-center font-jost text-[14px] font-medium leading-normal uppercase">
              JOIN
            </span>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default BotBPassNavMenu;
